"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listDecoder = exports.tupleDecoder = exports.noneResult = exports.optionalDecoder = exports.responseSimpleDecoder = exports.defaultErrorDecoder = exports.bufferResult = exports.stringResult = exports.intResult = exports.contractResult = exports.addressResult = exports.principalResult = exports.boolResult = exports.ClarityError = void 0;
const transactions_1 = require("@stacks/transactions");
class ClarityError extends Error {
    constructor(code) {
        super(`ClarityError: ${code}`);
        this.code = code;
    }
}
exports.ClarityError = ClarityError;
const boolResult = (result) => {
    if (result.type === transactions_1.ClarityType.BoolTrue) {
        return true;
    }
    if (result.type === transactions_1.ClarityType.BoolFalse) {
        return false;
    }
    throw new Error(`Expected integer, got ${result.type}`);
};
exports.boolResult = boolResult;
const principalResult = (result) => {
    if (result.type === transactions_1.ClarityType.PrincipalStandard) {
        return (0, exports.addressResult)(result);
    }
    else if (result.type === transactions_1.ClarityType.PrincipalContract) {
        return (0, exports.contractResult)(result);
    }
    throw new Error(`Expected principal, got ${result.type}`);
};
exports.principalResult = principalResult;
const addressResult = (result) => {
    if (result.type === transactions_1.ClarityType.PrincipalStandard) {
        return (0, transactions_1.addressToString)(result.address);
    }
    throw new Error(`Expected principal, got ${result.type}`);
};
exports.addressResult = addressResult;
const contractResult = (result) => {
    if (result.type === transactions_1.ClarityType.PrincipalContract) {
        return `${(0, transactions_1.addressToString)(result.address)}.${result.contractName.content}`;
    }
    throw new Error(`Expected principal, got ${result.type}`);
};
exports.contractResult = contractResult;
const intResult = (result) => {
    if (result.type === transactions_1.ClarityType.Int || result.type === transactions_1.ClarityType.UInt) {
        return result.value;
    }
    throw new Error(`Expected integer, got ${result.type}`);
};
exports.intResult = intResult;
const stringResult = (result) => {
    if (result.type === transactions_1.ClarityType.StringASCII ||
        result.type === transactions_1.ClarityType.StringUTF8) {
        return result.data;
    }
    throw new Error(`Expected string, got ${result.type}`);
};
exports.stringResult = stringResult;
const bufferResult = (result) => {
    if (result.type === transactions_1.ClarityType.Buffer) {
        return result.buffer;
    }
    throw new Error(`Expected buffer, got ${result.type}`);
};
exports.bufferResult = bufferResult;
const defaultErrorDecoder = (value) => {
    if (value.type === transactions_1.ClarityType.StringASCII ||
        value.type === transactions_1.ClarityType.StringUTF8) {
        return new Error(value.data);
    }
    if (value.type === transactions_1.ClarityType.UInt || value.type === transactions_1.ClarityType.Int) {
        return new ClarityError(Number(value.value));
    }
    return new Error("Unknown error");
};
exports.defaultErrorDecoder = defaultErrorDecoder;
function responseSimpleDecoder(success, failure = exports.defaultErrorDecoder) {
    return (value) => {
        if (value.type === transactions_1.ClarityType.ResponseErr) {
            return {
                type: "error",
                error: failure(value.value),
            };
        }
        if (value.type === transactions_1.ClarityType.ResponseOk) {
            return {
                type: "success",
                value: success(value.value),
            };
        }
        throw new Error(`Expected response, got ${value.type}`);
    };
}
exports.responseSimpleDecoder = responseSimpleDecoder;
function optionalDecoder(decoder) {
    return (value) => {
        if (value.type === transactions_1.ClarityType.OptionalNone) {
            return undefined;
        }
        else if (value.type === transactions_1.ClarityType.OptionalSome) {
            return decoder(value.value);
        }
        return decoder(value);
    };
}
exports.optionalDecoder = optionalDecoder;
const noneResult = (result) => {
    if (result.type === transactions_1.ClarityType.OptionalNone) {
        return null;
    }
    throw new Error(`Expected none, got ${result.type}`);
};
exports.noneResult = noneResult;
function tupleDecoder(decorators) {
    return (input) => {
        if (input.type !== transactions_1.ClarityType.Tuple) {
            throw new Error(`Expected tuple, got ${input.type}`);
        }
        const result = {};
        for (const key of Object.keys(decorators)) {
            result[key] = decorators[key](input.data[key]);
        }
        return result;
    };
}
exports.tupleDecoder = tupleDecoder;
function listDecoder(decoder) {
    return (value) => {
        if (value.type === transactions_1.ClarityType.List) {
            return value.list.map(decoder);
        }
        throw new Error(`Expected list, got ${value.type}`);
    };
}
exports.listDecoder = listDecoder;
